import { render } from "./ContentHeader.vue?vue&type=template&id=bd3c3686"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ARCHIVOS\\PROYECCION SERVIDOR\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__